/**
 * @generated SignedSource<<83ae47a1dd7c9d6e7490e5cb991faf4c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CreateSubscriptionDialogCustomerAccountsQuery$variables = {
  searchTerm: string;
};
export type CreateSubscriptionDialogCustomerAccountsQuery$data = {
  readonly customerAccounts: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly customerName: string;
        readonly customerNumber: string;
        readonly id: string;
      } | null | undefined;
    }>;
    readonly totalCount: number;
  } | null | undefined;
};
export type CreateSubscriptionDialogCustomerAccountsQuery = {
  response: CreateSubscriptionDialogCustomerAccountsQuery$data;
  variables: CreateSubscriptionDialogCustomerAccountsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "searchTerm"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "searchTerm",
        "variableName": "searchTerm"
      },
      {
        "kind": "Literal",
        "name": "sort",
        "value": "CUSTOMER_SINCE_DESC"
      }
    ],
    "concreteType": "CustomerAccountConnection",
    "kind": "LinkedField",
    "name": "customerAccounts",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "CustomerAccountEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CustomerAccount",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "customerName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "customerNumber",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateSubscriptionDialogCustomerAccountsQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateSubscriptionDialogCustomerAccountsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "6d8cccbe43837f7dc5ba9e32009dedc8",
    "id": null,
    "metadata": {},
    "name": "CreateSubscriptionDialogCustomerAccountsQuery",
    "operationKind": "query",
    "text": "query CreateSubscriptionDialogCustomerAccountsQuery(\n  $searchTerm: String!\n) {\n  customerAccounts(searchTerm: $searchTerm, sort: CUSTOMER_SINCE_DESC) {\n    totalCount\n    edges {\n      node {\n        id\n        customerName\n        customerNumber\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5239a8acb165041e771cb56bc2e07e1a";

export default node;
